{
  "remove": "Odebrat"
}
